import { Pump } from "@/types/pump";

export function getPumpFormValue(value: unknown): string | undefined {
    if (!value) return undefined;
    if (typeof value === "string") return value;
    if (
        typeof value === "object" &&
        "target" in value &&
        value.target &&
        typeof value.target === "object" &&
        "value" in value.target
    ) {
        const targetValue = value.target.value;
        return targetValue ? String(targetValue) : undefined;
    }
    return undefined;
}

export function getPumpIdFromFormValue(value: unknown): number | null {
    const pumpValue = getPumpFormValue(value);
    if (!pumpValue) return null;
    const pumpId = Number(pumpValue.split("-")[0]);
    return Number.isNaN(pumpId) ? null : pumpId;
}

export function getPumpName(pump: Pump, index?: number) {
    let pumpName = "";
    if (pump.system_type === 3) {
        pumpName = `${pump.pump_make ?? ""} Pump ${
            index ? index + 1 : ""
        } (Constant)`;
    } else if (pump.system_type === 2) {
        pumpName = `${pump.pump_model ?? ""} ${pump.pump_serial_number ?? ""} (VRF)`;
    }
    return pumpName;
}
